module.exports = __webpack_public_path__ + "static/img/9.69bc467c.png";